export default __webpack_public_path__ + "05bf1f641d227cb098983eda9a7870bd.png";